<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <preview-popup
        :preview-data="previewData"
        :show-preview="preview"
        @hide-preview="hidePreview"
    />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a class="btn btn_action btn_grey btn_preview"
             :title="'Náhled' | translate"
             @click.stop="showPreview"
             v-translate>Náhled</a>
          <a v-if="$_createActionAllowed"
             class="btn btn_action btn_grey btn_new_message"
             :title="'Použít šablonu' | translate"
             @click.prevent.stop="useTemplate"
             v-translate>Použít šablonu</a>
          <a v-if="$_deleteActionAllowed"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_readActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr typu šablony</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <p class="field">
                  <filter-checkbox
                      id="templateIsGlobal"
                      name="templateIsGlobal"
                      :val="isGlobal"
                      v-model="isGlobalComputed"
                      :disabled="true"
                  >
                    <translate class="translate">Globální šablona</translate>
                  </filter-checkbox>
                </p>
              </div>
              <div class="field_right" v-show="!isGlobalComputed">
                <select-box
                    id="operator"
                    v-model="entity.id_operator"
                    :options="operatorOptions"
                    :disabled="true"
                >
                  <translate>Operátor</translate>
                </select-box>
              </div>
            </div>
          </section>
          <message-template-basic-info
              ref="messagetemplatebasicref"
              :entity="entity"
          />
          <form-buttons
              v-if="$_updateActionAllowed"
              :module-name="moduleName"
              :custom-submit-text="'Uložit šablonu' | translate"
              @submit-form="submitForm"
          ></form-buttons>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import MessageTemplateBasicInfo from "./settings/MessageTemplateBasicInfo"
import messageTemplates from "./mixins/messageTemplates"
import FormButtons from "../../common/FormButtons"
import detailActions from "@/components/mixins/detail-actions"
import PreviewPopup from "../messages/popup/PreviewPopup.vue";

export default {
  name: "MessageTemplateDetail",
  components: {FormButtons, MessageTemplateBasicInfo, PreviewPopup},
  mixins: [detailActions, messageTemplates],
  created: function (MessageTemplateService, OperatorService) {
    this.entityService = MessageTemplateService
    this.operatorService = OperatorService
    this.createdInit()
        .then(() => {
          if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
            this.getOperators(true)
          }
        })
  },
  data: function () {
    return {
      preview: false,
      previewData: {},
    }
  },
  methods: {
    submitForm(redirect = false) {
      this.$refs.messagetemplatebasicref.saveCurrentTranslation()
      this.updateEntity(this.entity, redirect)
    },
    useTemplate() {
      this.$router.push({name: "messageNewFromTemplate", params: {id_template: this.entity.id}})
    },
    showPreview() {
      this.previewData = this.$refs.messagetemplatebasicref.saveCurrentTranslation()
      this.preview = true
    },
    hidePreview() {
      this.preview = false
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/MessageTemplateDetail.vue